export const iconFontAwesomeTravelHotelRocket = (
	<i className="fa-solid fa-rocket"></i>
);
